import React from 'react'
import { Button, Tooltip } from 'antd'

interface Props {
    item: string
    sensor: Array<String>
}

const Item: React.FC<Props> = (props) => {
    const { item, sensor } = props
    const ref = React.useRef<any>()

    const copy = (e: any) => {
        if (navigator.clipboard) navigator.clipboard.writeText(sensor.join(','))
        else {
            const textarea = document.createElement('textarea')
            textarea.value = sensor.join(',')
            document.body.appendChild(textarea)
            textarea.focus()
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
        }
    }

    return (
        <tr>
            <td>{item}</td>
            <td>{sensor.length}</td>
            <td>
                <div
                    ref={ref}
                    style={{ minHeight: '100px', width: '100%', border: '1px solid black', wordBreak: 'break-all' }}
                >
                    {sensor.join(',')}
                </div>
            </td>
            <td>
                <Tooltip placement="topLeft" title="Copied to clipboard" trigger="click" arrowPointAtCenter>
                    <Button type="link" onClick={copy}>
                        Copy
                    </Button>
                </Tooltip>
            </td>
        </tr>
    )
}

export default Item
